import React from 'react';
import { useBasicInfo } from '../data/menuData';
import chefImage from '../assets/chef.svg'; // Fallback image

const AboutSection = () => {
  const { basicInfo, loading } = useBasicInfo();
  
  return (
    <section id="about" className="pt-12 pb-20 bg-white">
      <div className="max-w-6xl mx-auto px-5">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-segoe font-bold text-gray-800 mb-4">About Us</h2>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h3 className="text-3xl font-dm-sans font-bold text-gray-800">Every Slice Tells a Story</h3>
            
            <p className="text-xl text-gray-600 leading-relaxed font-segoeNormal">
            Based in kolkata and crafted by Pastry Chef Aparna Singh, Vanilla Sky Bakehouse is where timeless baking meets bold imagination. We specialise in artisanal cakes that are anything but ordinary, with soft carrot walnut loaves, velvety Basque cheesecakes, and golden apple crumble cakes that feel like a warm hug.
            </p>
            
            <p className="text-xl text-gray-600 leading-relaxed font-segoeNormal">
            Every recipe is born from curiosity, perfected with technique, and finished with heart. Whether you’re craving comfort or something new, our bakes are crafted to linger in memory, long after the last bite.
            </p>
            

          </div>
          
          <div className="flex justify-center">
            <div className="relative">
              <div className="w-80 h-80 bg-gradient-to-br from-primary to-primary-light rounded-full flex items-center justify-center shadow-2xl relative overflow-hidden">
                {loading ? (
                  <div className="flex items-center justify-center w-full h-full">
                    <i className="fas fa-spinner fa-spin text-white text-4xl"></i>
                  </div>
                ) : basicInfo && basicInfo.chefImageUrl ? (
                  <img 
                    src={basicInfo.chefImageUrl} 
                    alt="Chef Aparna Singh" 
                    className="w-full h-full object-cover rounded-full"
                  />
                ) : (
                  <img 
                    src={chefImage} 
                    alt="Chef Aparna Singh" 
                    className="w-full h-full object-cover rounded-full"
                  />
                )}
                <i className="fas fa-user-chef text-white text-6xl relative z-10"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 